(() => {
  // Delegation also covers cards inserted by filtering and infinite scroll.
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-aya-reservation-link], .globo--add-to-cart');
    if (!trigger) return;
    const card = trigger.closest('product-item[data-aya-requires-reservation]');
    if (!card) return;
    const path = card.getAttribute('data-aya-product-url');
    if (!path) return;

    const url = new URL(path, window.location.origin);
    const variant = card.querySelector('select[name="idGlobo"]')?.value;
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);

    if (trigger.matches('[data-aya-reservation-link]')) {
      trigger.href = url.href;
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    }
    // Complete this navigation before third-party quick-add handlers.
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }, true);
})();


(() => {
  const mobileViewport = window.matchMedia("(max-width: 999px)");
  if (document.documentElement.dataset.ayaPage !== "product") return;
  let scheduled = false;

  const updateStickyButton = () => {
    scheduled = false;
    const stickyForm = document.querySelector("product-sticky-form");
    const mainButton = document.querySelector(
      ".product-form [data-product-add-to-cart-button]:not(#StickyAddToCart)"
    );
    if (!stickyForm || !mainButton) return;
    if (!mobileViewport.matches) return;
    stickyForm.hidden = mainButton.getBoundingClientRect().bottom > 0;
  };

  const scheduleUpdate = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateStickyButton);
  };

  document.addEventListener("DOMContentLoaded", scheduleUpdate);
  document.addEventListener("variant:changed", scheduleUpdate);
  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
})();

(() => {
  const BAR_SELECTORS = ["#bundle-smart_bar_container", "#bundle-smart_bar"];
  const root = document.documentElement;
  let observedBar = null;
  let resizeObserver = null;
  let raf = 0;

  const style = document.createElement("style");
  style.id = "aya-vitals-smartbar-offset";
  style.textContent = `
    html.aya-vitals-smartbar-visible body {
      padding-top: var(--aya-vitals-smartbar-height, 0px) !important;
    }
    html.aya-vitals-smartbar-visible .shopify-section--announcement-bar {
      top: var(--aya-vitals-smartbar-height, 0px) !important;
    }
    html.aya-vitals-smartbar-visible .shopify-section--header {
      top: calc(
        var(--aya-vitals-smartbar-height, 0px) +
        var(--enable-sticky-announcement-bar, 0) * var(--announcement-bar-height, 0px)
      ) !important;
    }
    html.aya-vitals-smartbar-visible mini-cart,
    html.aya-vitals-smartbar-visible #mini-cart {
      top: var(--aya-vitals-smartbar-height, 0px) !important;
      max-height: calc(100vh - var(--aya-vitals-smartbar-height, 0px)) !important;
    }
    html.aya-vitals-smartbar-visible .aya-vitals-protected-close {
      top: calc(var(--aya-vitals-smartbar-height, 0px) + 10px) !important;
      z-index: 2147483000 !important;
    }
  `;
  document.head.appendChild(style);

  const getBar = () => {
    for (const selector of BAR_SELECTORS) {
      const el = document.querySelector(selector);
      if (el) return el;
    }
    return null;
  };

  const isVisible = (el) => {
    if (!el || !el.isConnected) return false;
    const cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || Number(cs.opacity) === 0) return false;
    const rect = el.getBoundingClientRect();
    return rect.height > 0 && rect.width > 0;
  };

  const protectCloseButtons = (bar) => {
    document.querySelectorAll(".aya-vitals-protected-close").forEach((el) => {
      el.classList.remove("aya-vitals-protected-close");
    });
    if (!bar) return;

    const candidates = document.querySelectorAll([
      'button[data-action="close"]',
      'button[aria-label*="cerrar" i]',
      'button[aria-label*="close" i]',
      'button[title*="cerrar" i]',
      'button[title*="close" i]',
      '.drawer__close-button',
      '.popover__close-button'
    ].join(','));

    candidates.forEach((button) => {
      if (bar.contains(button)) return;
      const cs = window.getComputedStyle(button);
      if (cs.display === "none" || cs.visibility === "hidden") return;
      const rect = button.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      const positioned = cs.position === "fixed" || cs.position === "absolute" || cs.position === "sticky";
      if (positioned && rect.top < Math.ceil(bar.getBoundingClientRect().height) + 12) {
        button.classList.add("aya-vitals-protected-close");
      }
    });
  };

  const update = () => {
    raf = 0;
    mutationObserver.disconnect();
    try {
      const bar = getBar();
      if (bar !== observedBar) {
        if (resizeObserver) resizeObserver.disconnect();
        observedBar = bar;
        if (bar && "ResizeObserver" in window) {
          resizeObserver = new ResizeObserver(scheduleUpdate);
          resizeObserver.observe(bar);
        }
      }
      if (!isVisible(bar)) {
        if (root.classList.contains("aya-vitals-smartbar-visible")) {
          root.classList.remove("aya-vitals-smartbar-visible");
        }
        if (root.style.getPropertyValue("--aya-vitals-smartbar-height")) {
          root.style.removeProperty("--aya-vitals-smartbar-height");
        }
        protectCloseButtons(null);
        return;
      }
      const height = Math.ceil(bar.getBoundingClientRect().height);
      const heightValue = `${height}px`;
      if (root.style.getPropertyValue("--aya-vitals-smartbar-height") !== heightValue) {
        root.style.setProperty("--aya-vitals-smartbar-height", heightValue);
      }
      if (!root.classList.contains("aya-vitals-smartbar-visible")) {
        root.classList.add("aya-vitals-smartbar-visible");
      }
      protectCloseButtons(bar);
    } finally {
      mutationObserver.observe(root, mutationOptions);
    }
  };

  function scheduleUpdate() {
    if (raf) return;
    raf = window.requestAnimationFrame(update);
  }

  const mutationOptions = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "hidden", "open"]
  };
  const mutationObserver = new MutationObserver(scheduleUpdate);
  mutationObserver.observe(root, mutationOptions);

  document.addEventListener("DOMContentLoaded", scheduleUpdate);
  window.addEventListener("load", scheduleUpdate);
  window.addEventListener("resize", scheduleUpdate);
  scheduleUpdate();
})();

(() => {
  const style = document.createElement("style");
  style.id = "aya-mobile-facet-toolbar-sticky";
  style.textContent = `
    @media screen and (max-width: 999px) {
      #mobile-facet-toolbar {
        position: -webkit-sticky;
        position: sticky;
        top: calc(
          var(--aya-vitals-smartbar-height, 0px) +
          var(--enable-sticky-announcement-bar, 0) * var(--announcement-bar-height, 0px) +
          var(--enable-sticky-header, 0) * var(--header-height, 0px)
        );
        z-index: 3;
        background: rgb(var(--background));
        box-shadow: 0 1px 0 rgba(38, 38, 38, 0.08), 0 5px 14px rgba(38, 38, 38, 0.05);
      }
    }
  `;
  document.head.appendChild(style);
})();

/* AyA: un único bloque compacto de envíos para ES y PT. */
(() => {
  if (document.documentElement.dataset.ayaPage !== "product") return;
  const locale = (document.documentElement.lang || "").toLowerCase();
  const isPt = locale.startsWith("pt");
  const ES_TARGET = /^Envío gratis en pedidos superiores a\s*€?\s*59(?:[,.]00)?\.?$/i;
  const PT_TARGET = /^(?:Portes|Envio)\s+grátis\s+(?:acima de|a partir de)\s*€?\s*59(?:[,.]00)?\.?$/i;
  const targetPattern = isPt ? PT_TARGET : ES_TARGET;
  let raf = 0;
  let observer = null;

  const style = document.createElement("style");
  style.id = "aya-product-shipping-markets-style";
  style.textContent = `
    .aya-product-shipping-markets {
      display: grid !important;
      gap: 8px !important;
      width: 100% !important;
      text-align: left !important;
      line-height: 1.35 !important;
    }
    .aya-product-shipping-market {
      display: flex !important;
      align-items: flex-start !important;
      gap: 8px !important;
    }
    .aya-product-shipping-market__flag {
      flex: 0 0 auto !important;
      font-size: 18px !important;
      line-height: 1.25 !important;
    }
    .aya-product-shipping-market__copy {
      display: block !important;
      min-width: 0 !important;
    }
    .aya-product-shipping-market__title {
      display: block !important;
      font-weight: 600 !important;
      color: inherit !important;
    }
    .aya-product-shipping-market__sub {
      display: block !important;
      margin-top: 1px !important;
      font-size: .82em !important;
      opacity: .72 !important;
    }
    @media screen and (max-width: 740px) {
      .aya-product-shipping-markets { gap: 7px !important; }
      .aya-product-shipping-market__title { font-size: .96em !important; }
      .aya-product-shipping-market__sub { font-size: .78em !important; }
    }
  `;
  if (!document.getElementById(style.id)) document.head.appendChild(style);

  const replacement = isPt ? `
    <span class="aya-product-shipping-markets" data-aya-shipping-markets="true">
      <span class="aya-product-shipping-market">
        <span class="aya-product-shipping-market__flag" aria-hidden="true">🇪🇸</span>
        <span class="aya-product-shipping-market__copy">
          <span class="aya-product-shipping-market__title">Espanha peninsular: envio grátis a partir de 59 €</span>
          <span class="aya-product-shipping-market__sub">4,95 € em encomendas inferiores</span>
        </span>
      </span>
      <span class="aya-product-shipping-market">
        <span class="aya-product-shipping-market__flag" aria-hidden="true">🇵🇹</span>
        <span class="aya-product-shipping-market__copy">
          <span class="aya-product-shipping-market__title">Portugal: envio grátis a partir de 99 €</span>
          <span class="aya-product-shipping-market__sub">5,95 € em encomendas inferiores</span>
        </span>
      </span>
    </span>` : `
    <span class="aya-product-shipping-markets" data-aya-shipping-markets="true">
      <span class="aya-product-shipping-market">
        <span class="aya-product-shipping-market__flag" aria-hidden="true">🇪🇸</span>
        <span class="aya-product-shipping-market__copy">
          <span class="aya-product-shipping-market__title">España península: envío gratis desde 59 €</span>
          <span class="aya-product-shipping-market__sub">4,95 € en pedidos inferiores</span>
        </span>
      </span>
      <span class="aya-product-shipping-market">
        <span class="aya-product-shipping-market__flag" aria-hidden="true">🇵🇹</span>
        <span class="aya-product-shipping-market__copy">
          <span class="aya-product-shipping-market__title">Portugal: envío gratis desde 99 €</span>
          <span class="aya-product-shipping-market__sub">5,95 € en pedidos inferiores</span>
        </span>
      </span>
    </span>`;

  const depth = (el) => {
    let n = 0;
    while (el && el.parentElement) { n += 1; el = el.parentElement; }
    return n;
  };

  const apply = () => {
    raf = 0;
    if (document.querySelector('[data-aya-shipping-markets="true"]')) {
      if (observer) observer.disconnect();
      return;
    }

    const candidates = Array.from(document.querySelectorAll(".product__info p, .product__info li, .product__info span, .product__info div"))
      .filter((el) => {
        if (el.closest('[data-aya-shipping-markets="true"]')) return false;
        const text = (el.textContent || "").replace(/\s+/g, " ").trim();
        return targetPattern.test(text);
      })
      .sort((a, b) => depth(b) - depth(a));

    const target = candidates[0];
    if (!target) return;
    target.innerHTML = replacement;
    target.setAttribute("data-aya-shipping-markets", "true");
    if (observer) observer.disconnect();
  };

  const schedule = () => {
    if (raf) return;
    raf = window.requestAnimationFrame(apply);
  };

  observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("DOMContentLoaded", schedule);
  window.addEventListener("load", schedule);
  schedule();
})();

/* AyA: fuerza el botón flotante real de WhatsApp a la izquierda, alineado sobre cookies. */
(() => {
  const MOBILE = window.matchMedia('(max-width: 999px)');
  let raf = 0;
  let adjustedCookie = null;
  const cookieOriginals = new WeakMap();

  const isWhatsapp = (el) => {
    if (!el || !el.matches) return false;
    const href = (el.getAttribute('href') || '').toLowerCase();
    const aria = (el.getAttribute('aria-label') || '').toLowerCase();
    const title = (el.getAttribute('title') || '').toLowerCase();
    const idc = `${el.id || ''} ${el.className || ''}`.toLowerCase();
    return href.includes('wa.me') || href.includes('whatsapp') || aria.includes('whatsapp') || title.includes('whatsapp') || idc.includes('whatsapp') || idc.includes('rt-wa');
  };

  const visibleFixed = (el) => {
    if (!el || !el.isConnected) return false;
    const cs = getComputedStyle(el);
    const r = el.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width >= 38 && r.height >= 38 && (cs.position === 'fixed' || el.closest('[style*="position: fixed"], [style*="position:fixed"]'));
  };

  const getCookieButton = () => {
    const own = document.getElementById('aya-cookie-settings-button');
    if (own && own.getBoundingClientRect().width >= 35 && own.getBoundingClientRect().height >= 35) return own;
    const selectors = [
      '#Avada-CookiesBar button',
      '#Avada-CookiesBar .Avada-CookiesMobile',
      '[id*="cookie" i] button',
      '[class*="cookie" i] button'
    ];
    for (const sel of selectors) {
      const items = Array.from(document.querySelectorAll(sel)).filter((el) => {
        const r = el.getBoundingClientRect();
        return r.width >= 35 && r.height >= 35 && r.bottom > window.innerHeight - 180;
      });
      if (items.length) return items.sort((a,b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left)[0];
    }
    return null;
  };

  const findWhatsapp = () => {
    const launcher = document.querySelector('button.aya-whatsapp-float');
    return launcher && visibleFixed(launcher) ? launcher : null;
  };

  const apply = () => {
    raf = 0;
    observer.disconnect();
    try {
    if (!MOBILE.matches) {
      if (adjustedCookie) {
        const original = cookieOriginals.get(adjustedCookie);
        if (original.value) adjustedCookie.style.setProperty('bottom', original.value, original.priority);
        else adjustedCookie.style.removeProperty('bottom');
        adjustedCookie = null;
      }
      return;
    }
    const wa = findWhatsapp();
    if (!wa) return;
    const cookie = getCookieButton();
    const left = cookie ? Math.max(20, Math.round(cookie.getBoundingClientRect().left)) : 24;
    const ownCookie = cookie && cookie.id === 'aya-cookie-settings-button';
    const cookieHeight = cookie ? cookie.getBoundingClientRect().height : 0;
    let cookieBottom = 80;
    let bottom = ownCookie ? cookieBottom + cookieHeight + 12 : Math.max(96, cookie ? Math.round(window.innerHeight - cookie.getBoundingClientRect().top + 12) : 96);
    const waRect = wa.getBoundingClientRect();
    const controls = Array.from(document.querySelectorAll('.product__info [data-product-add-to-cart-button], .product__info .product-form__button a[href*="guia-de-tallas"]'))
      .map((control) => control.getBoundingClientRect())
      .filter((rect) => rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight)
      .sort((a, b) => b.top - a.top);
    for (const rect of controls) {
      const groupTop = window.innerHeight - bottom - waRect.height;
      const groupBottom = window.innerHeight - (ownCookie ? cookieBottom : bottom);
      if (rect.right > left && rect.left < left + waRect.width && rect.bottom > groupTop - 8 && rect.top < groupBottom + 8) {
        const shift = groupBottom - rect.top + 12;
        bottom += shift;
        cookieBottom += shift;
      }
    }
    if (ownCookie) {
      if (!cookieOriginals.has(cookie)) cookieOriginals.set(cookie, {value: cookie.style.getPropertyValue('bottom'), priority: cookie.style.getPropertyPriority('bottom')});
      adjustedCookie = cookie;
      const cookieValue = `${Math.round(cookieBottom)}px`;
      if (cookie.style.getPropertyValue('bottom') !== cookieValue || cookie.style.getPropertyPriority('bottom') !== 'important') {
        cookie.style.setProperty('bottom', cookieValue, 'important');
      }
    }

    const positionStyles = {
      position: 'fixed',
      left: `${left}px`,
      right: 'auto',
      bottom: `${Math.round(bottom)}px`,
      top: 'auto',
      'margin-left': '0px',
      transform: 'none',
      'z-index': '2147482500'
    };
    for (const [property, value] of Object.entries(positionStyles)) {
      if (wa.style.getPropertyValue(property) !== value || wa.style.getPropertyPriority(property) !== 'important') {
        wa.style.setProperty(property, value, 'important');
      }
    }
    const panel = document.getElementById('aya-whatsapp-panel');
    if (panel) {
      const panelStyles = {left: '12px', bottom: `${Math.round(bottom + waRect.height + 12)}px`, 'max-height': `calc(100dvh - ${Math.round(bottom + waRect.height + 36)}px)`};
      for (const [property, value] of Object.entries(panelStyles)) {
        if (panel.style.getPropertyValue(property) !== value) panel.style.setProperty(property, value);
      }
    }
    if (wa.dataset.ayaWhatsappLeft !== 'true') wa.dataset.ayaWhatsappLeft = 'true';
    } finally {
      observer.observe(document.documentElement, observerOptions);
    }
  };

  const schedule = () => {
    if (!MOBILE.matches && !adjustedCookie) return;
    if (raf) return;
    raf = requestAnimationFrame(apply);
  };

  const observerOptions = {childList:true, subtree:true, attributes:true, attributeFilter:['style','class']};
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, observerOptions);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, {passive:true});
  setTimeout(schedule, 800);
  setTimeout(schedule, 1800);
  setTimeout(schedule, 3500);
  schedule();
})();

/* AyA: el carrito muestra únicamente complementos reales del producto, nunca relacionados genéricos. */
(() => {
  const processed = new WeakSet();
  let scanRaf = 0;

  const recommendationsRoot = () => {
    const root = window.Shopify && Shopify.routes && Shopify.routes.root;
    return root || '/';
  };

  const emptyReplacement = (target, reason) => {
    const placeholder = document.createElement('div');
    placeholder.className = 'mini-cart__recommendations aya-complementary-recommendations';
    placeholder.hidden = true;
    placeholder.dataset.ayaComplementary = reason || 'empty';
    if (target.isConnected) target.replaceWith(placeholder);
  };

  const loadComplementary = async (target) => {
    if (!target || processed.has(target) || !target.isConnected) return;
    processed.add(target);

    const productId = target.getAttribute('product-id');
    const sectionId = target.getAttribute('section-id');
    if (!productId || !sectionId) {
      emptyReplacement(target, 'missing-source');
      return;
    }

    target.setAttribute('aria-busy', 'true');
    target.style.visibility = 'hidden';

    const root = recommendationsRoot();
    const url = `${root}recommendations/products?section_id=${encodeURIComponent(sectionId)}&product_id=${encodeURIComponent(productId)}&limit=3&intent=complementary`;

    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error(`recommendations ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const source = doc.querySelector('cart-drawer-recommendations.mini-cart__recommendations');
      const content = source && source.querySelector('.mini-cart__recommendations-inner');

      if (!source || !content || !content.querySelector('product-item')) {
        emptyReplacement(target, 'empty');
        return;
      }

      const replacement = document.createElement('div');
      replacement.className = 'mini-cart__recommendations aya-complementary-recommendations';
      replacement.dataset.ayaComplementary = 'ready';
      replacement.innerHTML = source.innerHTML;

      const cards = Array.from(replacement.querySelectorAll('.mini-cart__recommendations-list > product-item'));
      cards.slice(3).forEach((card) => card.remove());

      if (!replacement.querySelector('.mini-cart__recommendations-list > product-item')) {
        emptyReplacement(target, 'empty');
        return;
      }

      target.replaceWith(replacement);
    } catch (error) {
      console.warn('[AyA] No se pudieron cargar complementos del carrito:', error);
      emptyReplacement(target, 'error');
    }
  };

  const scan = () => {
    scanRaf = 0;
    document.querySelectorAll('cart-drawer-recommendations.mini-cart__recommendations').forEach(loadComplementary);
  };

  const scheduleScan = () => {
    if (scanRaf) return;
    scanRaf = requestAnimationFrame(scan);
  };

  new MutationObserver(scheduleScan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scheduleScan);
  document.addEventListener('shopify:section:load', scheduleScan);
  window.addEventListener('load', scheduleScan);
  scheduleScan();
})();

(() => {
  const sizeNames = ['filter.v.option.talla', 'filter.v.option.tallas'];
  const sizeSelector = sizeNames.map(name => 'input[name="' + name + '"]').join(', ');
  const hasSize = params => sizeNames.some(name => params.getAll(name).some(Boolean));
  const normalize = value => {
    const url = new URL(value, window.location.origin);
    if (hasSize(url.searchParams)) url.searchParams.set('filter.v.availability', '1');
    else url.searchParams.delete('filter.v.availability');
    return url;
  };
  const ready = () => {
    const form = document.querySelector('#facet-filters-form');
    if (!form?.querySelector('input[name="filter.v.availability"]')) return;
    const url = normalize(window.location.href);
    if (url.href !== window.location.href) {
      url.searchParams.delete('page');
      window.location.replace(url.href);
    }
  };
  document.addEventListener('change', event => {
    if (!(event.target instanceof HTMLInputElement) || !event.target.matches(sizeSelector)) return;
    const form = event.target.closest('#facet-filters-form');
    const available = form?.querySelector('input[name="filter.v.availability"]');
    if (!available) return;
    available.disabled = !Array.from(form.querySelectorAll(sizeSelector)).some(input => input.checked);
  }, true);
  document.addEventListener('facet:criteria-changed', event => {
    if (!event.detail?.url || !document.querySelector('#facet-filters-form input[name="filter.v.availability"]')) return;
    event.detail.url = normalize(event.detail.url).href;
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true });
  else ready();
})();

(() => {
  document.addEventListener('click', async event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-aya-copy-code]');
    if (!button) return;
    const status = button.closest('.aya-coupon-copy')?.querySelector('[role="status"]');
    if (!status) return;
    try {
      await navigator.clipboard.writeText(button.dataset.ayaCopyCode);
      status.textContent = button.dataset.copySuccess;
    } catch {
      status.textContent = button.dataset.copyFallback;
    }
  });
})();

(() => {
  const synced = new WeakMap();
  let queued = false;
  const syncCards = () => {
    queued = false;
    const params = new URLSearchParams(window.location.search);
    const sizes = [...params.getAll('filter.v.option.talla'), ...params.getAll('filter.v.option.tallas')];
    if (!sizes.length) return;
    const signature = sizes.join('|');
    document.querySelectorAll('#main product-item').forEach((card) => {
      const select = card.querySelector('select[name="idGlobo"]');
      if (!select || synced.get(select) === signature) return;
      const option = Array.from(select.options).find((item) =>
        item.dataset.available === 'true' &&
        sizes.some((size) => [item.dataset.option1, item.dataset.option2, item.dataset.option3].includes(size))
      );
      if (!option) return;
      const radio = Array.from(card.querySelectorAll('input[type="radio"][data-gsw-swatch-change-bound="1"]')).find((item) =>
        item.id.startsWith('swatch-collection-' + option.value + '-') && sizes.includes(item.value)
      );
      if (!radio) return;
      synced.set(select, signature);
      if (!radio.checked || select.value !== option.value) radio.click();
    });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(syncCards);
  };
  const start = () => {
    const main = document.querySelector('#main');
    if (!main) return;
    new MutationObserver((records) => {
      if (records.some((record) => record.type === 'attributes' || Array.from(record.addedNodes).some((node) =>
        node instanceof Element && (node.matches('product-item, select, input') || node.querySelector('product-item, select[name="idGlobo"], input[type="radio"]'))
      ))) schedule();
    }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-gsw-swatch-change-bound'] });
    schedule();
  };
  document.addEventListener('facet:criteria-changed', schedule);
  window.addEventListener('popstate', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
